module.exports = __webpack_public_path__ + "static/Macallan Mockup-f8609012f2ac8e56eab0d868ac3c58b4.png";